/**
 * Persian labels for role names (fallback when backend does not send role_titles).
 * Backend /v1/user/info returns role_titles from Role.title; this map is used when titles are missing.
 */
export const ROLE_LABELS: Record<string, string> = {
  admin: 'ادمین',
  company: 'شرکت',
  user_company: 'کاربر شرکت',
  company_ceo: 'مدیر عامل شرکت',
  company_branch_manager: 'مدیر شعبه',
  company_office_manager: 'مدیر دفتر',
  company_office_user: 'کاربر دفتر',
  driver: 'راننده',
};

export function getRoleDisplayLabel(roleName: string, roleTitles?: string[], roleIndex?: number): string {
  if (roleTitles && roleIndex !== undefined && roleTitles[roleIndex]) {
    return roleTitles[roleIndex];
  }
  return ROLE_LABELS[roleName] ?? roleName;
}

export function getRoleDisplayLabels(roleNames: string[], roleTitles?: string[]): string[] {
  if (roleTitles && roleTitles.length === roleNames.length) {
    return roleTitles;
  }
  return roleNames.map((name) => ROLE_LABELS[name] ?? name);
}
